module.exports = __webpack_public_path__ + "static/media/hs-assembly.ffe68587.png";